export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_CARTS = "GET_CARTS";
export const ADD_CART = "ADD_CART";
export const DELETE_CART = "DELETE_CART";
export const UPDATE_CART = "UPDATE_CART";
export const GET_ORDERED = "GET_ORDERED";
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const FORM_SUBMISSION = "FORM_SUBMISSION";
export const SUBMISSION_SUCCESS = "SUBMISSION_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const MAKE_DEPOSIT = "MAKE_DEPOSIT";
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
export const PAYMENT_FAIL = "PAYMENT_FAIL";
export const CREATE_MESSAGE = "CREATE_MESSAGE";
export const GET_ERROR = "GET_ERROR";
